"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resumeBattleCommand = exports.pauseBattleCommand = exports.startBattleCommand = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.startBattleCommand = (0, toolkit_1.createAction)("startBattleCommand");
exports.pauseBattleCommand = (0, toolkit_1.createAction)("pauseBattleCommand");
exports.resumeBattleCommand = (0, toolkit_1.createAction)("resumeBattleCommand");
